import React, { FC } from 'react'
import { Select as StyledSelect, breakpoints } from '@gassan-ui'
import { useLocalization } from '@components/Localization'
import styled from 'styled-components'
import { useBreakpoint } from '@lib/hooks/useBreakpoint'
import { ringSizes } from '@lib/ringSizes'

type Props = {
  onChangeSize: (size: string) => void
  size: string
}

const Select = styled(StyledSelect)`
  z-index: 0;
  &:focus {
    z-index: 1;
  }
`

const SelectSize: FC<Props> = ({ onChangeSize, size }) => {
  const isDesktop = useBreakpoint(breakpoints.large)
  const { lang } = useLocalization()
  const prefix = !isDesktop ? (lang === 'nl' ? 'Maat ' : 'Size ') : ''

  return (
    <Select
      value={size}
      onChange={e => onChangeSize(e.target.value)}
      style={{ marginLeft: '-1px' }}
    >
      <option value="dont-know">{lang === 'nl' ? 'Weet ik niet' : "I don't know"}</option>
      {ringSizes.map((size, _) => (
        <option value={`${size}mm`} key={size}>
          {prefix}
          {size}
        </option>
      ))}
    </Select>
  )
}

export default SelectSize
